var _path, _path2, _path3, _path4, _path5, _defs, _clipPath, _g, _defs2, _clipPath2, _g2, _defs3, _clipPath3, _g3, _path6, _defs4, _clipPath4, _g4, _defs5, _clipPath5, _g5, _defs6, _clipPath6, _g6, _path7, _defs7, _clipPath7, _g7, _defs8, _clipPath8, _g8, _path8, _defs9, _clipPath9, _g9, _defs10, _clipPath10, _g10, _defs11, _clipPath11, _g11, _path9, _path10, _defs12, _clipPath12, _g12, _defs13, _clipPath13, _g13, _path11, _defs14, _clipPath14, _g14, _defs15, _clipPath15, _g15, _defs16, _clipPath16, _g16, _defs17, _clipPath17, _g17, _defs18, _clipPath18, _g18, _path12, _defs19, _clipPath19, _g19, _path13, _defs20, _clipPath20, _g20, _path14, _defs21, _clipPath21, _g21, _defs22, _clipPath22, _g22, _path15, _path16, _defs23, _clipPath23, _g23, _path17, _path18, _defs24, _clipPath24, _g24, _defs25, _clipPath25, _g25, _defs26, _clipPath26, _g26, _defs27, _clipPath27, _g27, _path19, _defs28, _clipPath28, _g28, _defs29, _clipPath29, _g29, _defs30, _clipPath30, _g30, _defs31, _clipPath31, _g31, _path20, _defs32, _clipPath32, _g32, _defs33, _clipPath33, _g33, _defs34, _clipPath34, _g34, _defs35, _clipPath35, _g35, _path21, _defs36, _clipPath36, _g36, _path22, _path23, _path24, _path25, _path26, _defs37, _clipPath37, _g37, _defs38, _clipPath38, _g38, _defs39, _clipPath39, _g39, _defs40, _clipPath40, _g40, _defs41, _clipPath41, _g41, _path27, _defs42, _clipPath42, _g42, _defs43, _clipPath43, _g43, _defs44, _clipPath44, _g44, _defs45, _clipPath45, _g45, _path28, _defs46, _clipPath46, _g46, _path29, _defs47, _clipPath47, _g47, _path30, _defs48, _clipPath48, _g48, _defs49, _clipPath49, _g49, _defs50, _clipPath50, _g50, _defs51, _clipPath51, _g51, _path31, _defs52, _clipPath52, _g52, _path32, _defs53, _clipPath53, _g53, _path33, _defs54, _clipPath54, _g54, _defs55, _clipPath55, _g55, _defs56, _clipPath56, _g56, _defs57, _clipPath57, _g57, _path34, _defs58, _clipPath58, _g58, _defs59, _clipPath59, _g59, _path35, _defs60, _clipPath60, _g60, _defs61, _clipPath61, _g61, _path36, _defs62, _clipPath62, _g62, _path37, _defs63, _clipPath63, _g63, _defs64, _clipPath64, _g64, _defs65, _clipPath65, _g65, _defs66, _clipPath66, _g66, _path38, _defs67, _clipPath67, _g67, _defs68, _clipPath68, _g68, _defs69, _clipPath69, _g69, _defs70, _clipPath70, _g70, _defs71, _clipPath71, _g71, _defs72, _clipPath72, _g72, _defs73, _clipPath73, _g73, _defs74, _clipPath74, _g74, _defs75, _clipPath75, _g75, _path39, _path40, _path41, _path42, _path43, _path44, _defs76, _clipPath76, _g76, _defs77, _clipPath77, _g77, _defs78, _clipPath78, _g78, _defs79, _clipPath79, _g79, _defs80, _clipPath80, _g80, _path45, _defs81, _clipPath81, _g81, _defs82, _clipPath82, _g82, _defs83, _clipPath83, _g83, _defs84, _clipPath84, _g84, _path46, _defs85, _clipPath85, _g85, _path47, _defs86, _clipPath86, _g86, _path48, _defs87, _clipPath87, _g87, _defs88, _clipPath88, _g88, _defs89, _clipPath89, _g89, _defs90, _clipPath90, _g90, _path49, _defs91, _clipPath91, _g91, _path50, _defs92, _clipPath92, _g92, _path51, _defs93, _clipPath93, _g93, _defs94, _clipPath94, _g94, _defs95, _clipPath95, _g95, _defs96, _clipPath96, _g96, _path52, _defs97, _clipPath97, _g97, _path53, _defs98, _clipPath98, _g98, _path54, _defs99, _clipPath99, _g99, _defs100, _clipPath100, _g100, _path55, _defs101, _clipPath101, _g101, _path56, _defs102, _clipPath102, _g102, _defs103, _clipPath103, _g103, _defs104, _clipPath104, _g104, _defs105, _clipPath105, _g105, _path57, _defs106, _clipPath106, _g106, _defs107, _clipPath107, _g107, _defs108, _clipPath108, _g108, _defs109, _clipPath109, _g109, _path58, _defs110, _clipPath110, _g110, _defs111, _clipPath111, _g111, _defs112, _clipPath112, _g112, _defs113, _clipPath113, _g113, _path59, _defs114, _clipPath114, _g114, _path60, _path61, _path62, _defs115, _clipPath115, _g115;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b18c56",
    d: "m41 57.72-14.91-8.11 17.13-2.41 14.91 8.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b18c56",
    d: "m37.82 58.17-14.91-8.11 3.18-.45L41 57.72z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b18c56",
    d: "M20.68 60.58 5.77 52.47l17.14-2.41 14.91 8.11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b6f42",
    d: "M20.68 64 5.77 55.89v-3.42l14.91 8.11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3a666",
    d: "m58.13 55.32-.01 3.42L20.68 64v-3.42l17.14-2.41 3.18-.45z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m56.89 48.98-14.91-8.11c.11.06.25.09.39.07.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-.14.02-.27 0-.39-.07z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m56.89 48.98-14.91-8.11c.01 0 .02.01.02.01L56.91 49c0-.01-.01-.01-.02-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M56.91 49 42 40.88c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m57.03 49.04-14.91-8.11c.08.02.16.03.25.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.08.01-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m57.5 48.99-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m57.62 48.92-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M57.71 48.85 42.8 40.74c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m57.78 48.77-14.91-8.11c.02-.03.05-.06.07-.09l14.91 8.11c-.02.03-.04.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m57.85 48.68-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M57.91 48.59 43 40.48c.02-.04.04-.08.06-.13l14.91 8.11c-.02.04-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m57.97 48.46-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c0 .11-.02.21-.06.31"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m56.89 48.98-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c.01.29.14.52.35.63z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m56.89 48.98-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c.01.29.14.52.35.63"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m46.45 30.97 14.91 8.11a1.23 1.23 0 0 0-.77-.13l-14.91-8.11c.28-.04.54.01.77.13z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m60.59 38.95-14.91-8.11c.17-.02.34-.01.5.03l14.91 8.11c-.16-.04-.33-.05-.5-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m61.09 38.98-14.91-8.11c.08.02.15.05.23.08l14.91 8.11c-.08-.03-.15-.06-.23-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M61.31 39.06 46.4 30.95c.01.01.03.01.04.02l14.91 8.11c-.01 0-.02-.01-.04-.02"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m58.03 48.15-14.91-8.11.01-5.64 14.91 8.12z"
  })), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "m42.78 33.78 14.91 8.11c.21.11.35.34.35.63L43.13 34.4c0-.28-.14-.51-.35-.62z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#g"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M58.04 42.52 43.13 34.4a.71.71 0 0 0-.35-.63l14.91 8.11c.21.12.35.35.35.64"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m53.26 49.49-14.91-8.11c.11.06.25.09.4.07.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-.15.02-.29 0-.4-.07z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#i"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m53.26 49.49-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M53.28 49.51 38.37 41.4c.04.02.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m53.4 49.55-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.02-.18.01-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m53.87 49.5-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m53.99 49.43-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m54.08 49.36-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m54.16 49.28-14.91-8.11c.02-.03.05-.06.07-.09l14.91 8.11c-.03.03-.05.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m54.22 49.19-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.01.04-.03.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m54.28 49.1-14.91-8.11c.02-.04.04-.08.06-.13l14.91 8.11c-.01.04-.03.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m54.34 48.97-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c0 .11-.02.21-.06.31"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m42.78 33.78 14.91 8.11a.638.638 0 0 0-.39-.07l-14.91-8.11c.14-.02.28.01.39.07z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#k"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m57.3 41.82-14.91-8.11c.09-.01.17-.01.25.01l14.91 8.11a.692.692 0 0 0-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m57.55 41.83-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m57.67 41.88-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11c-.01-.01-.01-.01-.02-.01"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m56.55 48.36-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m56.56 42.72-14.91-8.11c0-.44.34-.85.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#m"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m56.56 42.72-14.91-8.11c0-.11.02-.21.06-.31l14.91 8.11c-.04.1-.06.21-.06.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M56.61 42.41 41.7 34.3c.02-.04.03-.09.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m56.67 42.29-14.91-8.11c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.06-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m56.73 42.19-14.91-8.11a.55.55 0 0 1 .07-.09L56.8 42.1a.55.55 0 0 0-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "m56.8 42.1-14.91-8.11c.02-.03.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m56.87 42.03-14.91-8.11a.55.55 0 0 1 .09-.07l14.91 8.11a.55.55 0 0 0-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m56.96 41.95-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m57.08 41.88-14.91-8.11a.83.83 0 0 1 .21-.06l14.91 8.11a.83.83 0 0 0-.21.06"
  }))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "m53.26 49.49-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#o"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m53.26 49.49-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m54.4 48.66-14.91-8.11.01-5.64 14.91 8.12z"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "m39.15 34.29 14.91 8.11c.21.11.35.34.35.63L39.5 34.91c0-.28-.14-.51-.35-.62z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#q"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M54.41 43.03 39.5 34.91a.71.71 0 0 0-.35-.63l14.91 8.11c.21.12.35.35.35.64"
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "m49.63 50-14.91-8.11c.11.06.25.09.4.07.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-.15.02-.28 0-.4-.07z"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#s"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m49.63 50-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m49.65 50.02-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m49.77 50.06-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.02-.18.01-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M50.24 50.01 35.33 41.9c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m50.36 49.94-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m50.45 49.87-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m50.53 49.79-14.91-8.11c.02-.03.05-.06.07-.09L50.6 49.7a.55.55 0 0 0-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m50.6 49.7-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M50.66 49.61 35.75 41.5c.02-.04.04-.08.06-.13l14.91 8.11c-.02.04-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M50.71 49.48 35.8 41.37c.04-.1.06-.2.06-.31l14.91 8.11c0 .11-.02.21-.06.31"
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "m39.15 34.29 14.91 8.11a.638.638 0 0 0-.39-.07l-14.91-8.11c.14-.02.28.01.39.07z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#u"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m53.67 42.33-14.91-8.11c.09-.01.17-.01.25.01l14.91 8.11a.692.692 0 0 0-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m53.92 42.34-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m54.04 42.39-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11c-.01-.01-.01-.01-.02-.01"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m52.92 48.87-14.91-8.11.01-5.64 14.91 8.11z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M53.67 42.33c.41-.06.74.26.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "m52.93 43.23-14.91-8.11c0-.44.33-.84.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#w"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m52.93 43.23-14.91-8.11c0-.11.02-.22.06-.32l14.91 8.11c-.04.11-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m52.98 42.92-14.91-8.11c.02-.04.03-.08.06-.12l14.91 8.11c-.02.03-.04.08-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m53.04 42.79-14.91-8.11c.02-.03.04-.07.06-.1L53.1 42.7l-.06.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m53.1 42.7-14.91-8.11a.27.27 0 0 1 .07-.08l14.91 8.11a.27.27 0 0 0-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M53.17 42.61 38.26 34.5c.02-.03.05-.05.08-.08l14.91 8.11c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m53.24 42.54-14.91-8.11a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.02-.06.04-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m53.33 42.46-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m53.45 42.4-14.91-8.11c.07-.03.14-.05.22-.07l14.91 8.11c-.08.01-.15.03-.22.07"
  }))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "m49.63 50-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63z"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#y"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.63 50-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m50.77 49.17-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M31.48 42.47c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.33.84-.74.9-4.97-2.7-9.94-5.4-14.91-8.11z"
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#A"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.14 50.57-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.02-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M46.61 50.52 31.7 42.41c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m46.73 50.45-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m46.82 50.38-14.91-8.11c.03-.02.05-.05.08-.08L46.9 50.3c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m46.89 50.3-14.91-8.11c.02-.03.05-.05.07-.08l14.91 8.11c-.02.03-.04.06-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m46.96 50.22-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.03-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m47.02 50.12-14.91-8.11.06-.12L47.08 50l-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m47.08 50-14.91-8.11c.04-.1.06-.21.06-.32l14.91 8.11c-.01.11-.03.22-.06.32"
  }))), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M31.38 42.48c.03 0 .06 0 .1-.01 4.97 2.7 9.94 5.41 14.91 8.11-.03 0-.07.01-.1.01-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#C"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.14 50.57-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.02-.17.01-.25-.01"
  }))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "m35.52 34.8 14.91 8.11c.21.11.35.34.35.63l-14.91-8.11c0-.29-.14-.52-.35-.63z"
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#E"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m50.78 43.53-14.91-8.11a.71.71 0 0 0-.35-.63l14.91 8.11c.21.12.35.35.35.63"
  }))), _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M31.38 42.48c.05.01.1.05.14.08.16.08.31.17.47.25.2.11.41.22.61.33 4.56 2.48 9.13 4.96 13.69 7.45-.11 0-.21-.03-.29-.07L31.09 42.4c.09.05.19.08.29.08z"
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#G"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M46 50.51 31.09 42.4c.01 0 .02.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m46.02 50.53-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.14 50.57-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.02-.17.01-.25-.01"
  }))), _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "m35.52 34.8 14.91 8.11a.638.638 0 0 0-.39-.07l-14.91-8.11c.14-.02.28.01.39.07z"
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#I"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m50.04 42.84-14.91-8.11c.09-.01.17-.01.25.01l14.91 8.11a.692.692 0 0 0-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m50.29 42.85-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M50.41 42.9 35.5 34.79c.01 0 .02.01.02.01l14.91 8.11c0-.01-.01-.01-.02-.01"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m49.29 49.38-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "m49.3 43.74-14.91-8.11c0-.44.33-.84.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#K"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.3 43.74-14.91-8.11c0-.11.02-.22.06-.32l14.91 8.11c-.04.11-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.36 43.43-14.91-8.11c.02-.04.03-.08.06-.12l14.91 8.11c-.03.03-.05.07-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M49.41 43.3 34.5 35.19c.02-.03.04-.07.06-.1l14.91 8.11a.88.88 0 0 1-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M49.47 43.21 34.56 35.1a.27.27 0 0 1 .07-.08l14.91 8.11c-.02.02-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "m49.54 43.12-14.91-8.11c.02-.03.05-.05.08-.08l14.91 8.11c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M49.61 43.05 34.7 34.93a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.03-.06.05-.09.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m49.7 42.97-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M49.82 42.91 34.91 34.8c.07-.03.14-.05.22-.07l14.91 8.11c-.08.01-.15.03-.22.07"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M50.04 42.84c.41-.06.74.26.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M46 50.51 31.09 42.4c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63z"
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#M"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M46 50.51 31.09 42.4c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m47.13 49.68-14.91-8.11.01-5.64 14.91 8.12z"
  })), _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M32.23 35.93c0-.28-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.47-2.43-10.43-5.67-14.91-8.11z"
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#O"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m47.14 44.05-14.91-8.11c0-.28-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63"
  }))), _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "m31.89 35.31 14.91 8.11a.656.656 0 0 0-.4-.07l-14.9-8.11c.14-.02.28.01.39.07z"
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#Q"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M46.41 43.35 31.5 35.24c.09-.01.18-.01.26.01l14.91 8.11a.758.758 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m46.66 43.36-14.91-8.11c.04.01.08.02.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M46.78 43.41 31.87 35.3c.01 0 .02.01.02.01l14.91 8.11c-.01-.01-.01-.01-.02-.01"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m45.65 49.89-14.91-8.11.01-5.64 14.91 8.11z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M46.41 43.35c.41-.06.74.26.74.69l-.01 5.63c0 .44-.33.84-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c-.01-.43.33-.84.74-.9z"
  })), _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "m45.66 44.25-14.91-8.11c0-.44.34-.85.74-.9l14.91 8.11c-.4.06-.74.47-.74.9z"
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#S"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m45.66 44.25-14.91-8.11c0-.11.02-.21.06-.31l14.91 8.11c-.04.1-.06.21-.06.31m.06-.31-14.91-8.11c.02-.04.03-.09.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m45.78 43.82-14.91-8.11c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.06-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m45.84 43.72-14.91-8.11a.55.55 0 0 1 .07-.09l14.91 8.11a.55.55 0 0 0-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M45.91 43.63 31 35.52c.02-.03.05-.05.08-.08l14.91 8.11c-.04.03-.06.06-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m45.98 43.56-14.91-8.11a.55.55 0 0 1 .09-.07l14.91 8.11a.55.55 0 0 0-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m46.07 43.48-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M46.19 43.42 31.28 35.3a.83.83 0 0 1 .21-.06l14.91 8.11c-.07.01-.14.03-.21.07"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#886535",
    d: "m37.82 58.17-14.91-8.11.01-3.98 14.91 8.11z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad8047",
    d: "m37.83 54.19-14.91-8.11 3.17-.45L41 53.74z"
  })), _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M22.46 41.71c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.43-10.43-5.68-14.91-8.11z"
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#U"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m37.37 49.82-14.91-8.11c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m37.43 49.85-14.91-8.11c.09.04.18.08.27.1l14.91 8.11c-.09-.02-.19-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m37.7 49.95-14.91-8.11c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.02-.6-.03"
  }))), _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M25.13 39.75c0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47 0 1.03-.78 1.98-1.74 2.12l-14.91-8.11c.96-.13 1.74-1.08 1.74-2.12z"
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#W"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m38.3 49.98-14.91-8.11c.18-.02.35-.08.5-.15l14.91 8.11c-.16.08-.32.13-.5.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m38.8 49.83-14.91-8.11c.1-.05.19-.1.28-.16l14.91 8.11c-.08.06-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m39.09 49.67-14.91-8.11c.07-.05.14-.11.21-.17L39.3 49.5c-.07.06-.14.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m39.3 49.5-14.91-8.11.18-.18 14.91 8.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m39.47 49.32-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m39.63 49.12-14.91-8.11c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m39.77 48.89-14.91-8.11c.05-.09.09-.19.13-.29L39.9 48.6c-.03.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M39.91 48.6 25 40.49c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47 0 .25-.05.5-.13.73"
  }))), _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "m24.32 38.28 14.91 8.11c-.27-.15-.59-.21-.93-.16l-14.9-8.11c.34-.04.66.02.92.16z"
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#Y"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "M38.31 46.24 23.4 38.12c.21-.03.41-.02.6.03l14.91 8.11c-.19-.04-.39-.05-.6-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "M38.91 46.27 24 38.15c.1.02.19.06.27.1l14.91 8.11c-.09-.04-.18-.07-.27-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "m39.18 46.37-14.91-8.11c.02.01.04.02.05.03l14.91 8.11c-.01-.01-.03-.02-.05-.03"
  }))), _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aa",
    d: "m37.37 49.82-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.04.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.08-1.74 2.12.01.67.33 1.21.81 1.47z"
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aa"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#557d74",
    d: "m37.37 49.82-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.26.05-.51.13-.74l14.91 8.11c-.09.23-.13.48-.13.74.01.67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#578077",
    d: "M36.7 47.61 21.79 39.5c.04-.1.08-.2.13-.29l14.91 8.11c-.05.1-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a827a",
    d: "m36.83 47.32-14.91-8.11c.04-.08.09-.16.14-.23l14.91 8.11c-.05.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c857d",
    d: "m36.97 47.09-14.91-8.11c.05-.07.1-.14.16-.2l14.91 8.11a2.8 2.8 0 0 0-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f8980",
    d: "m37.13 46.9-14.91-8.11c.06-.06.11-.12.18-.18l14.91 8.11c-.07.05-.12.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "M37.31 46.72 22.4 38.61c.07-.06.14-.12.21-.17l14.91 8.11c-.08.05-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "m37.52 46.55-14.91-8.11c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "m37.8 46.39-14.91-8.11c.16-.08.33-.13.51-.15l14.91 8.11c-.18.02-.35.07-.51.15"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#80b5a7",
    d: "M38.31 46.24c.96-.13 1.73.59 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63 0-1.05.78-1.99 1.74-2.12z"
  })), _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "M14.81 42.79c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.44-10.43-5.68-14.91-8.11z"
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ac"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m29.72 50.9-14.91-8.11c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m29.78 50.92-14.91-8.11c.09.04.18.08.27.1l14.91 8.11a.88.88 0 0 1-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m30.05 51.03-14.91-8.11c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.01-.6-.03"
  }))), _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ae",
    d: "M17.48 40.83c0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47 0 1.03-.78 1.98-1.74 2.12l-14.91-8.11c.96-.14 1.74-1.09 1.74-2.12z"
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ae"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m30.65 51.06-14.91-8.11c.18-.02.35-.08.51-.15l14.91 8.11c-.17.07-.34.12-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M31.15 50.91 16.24 42.8c.1-.05.19-.1.28-.16l14.91 8.11c-.08.05-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m31.44 50.74-14.91-8.11c.07-.05.14-.11.21-.17l14.91 8.11c-.07.07-.14.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m31.65 50.58-14.91-8.11.18-.18 14.91 8.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m31.82 50.4-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m31.98 50.2-14.91-8.11c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m32.12 49.97-14.91-8.11c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m32.26 49.67-14.91-8.11c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47 0 .25-.05.5-.13.73"
  }))), _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ag",
    d: "m16.67 39.36 14.91 8.11c-.27-.15-.59-.21-.93-.16l-14.9-8.11c.34-.05.66.01.92.16z"
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ag"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "M30.66 47.31 15.75 39.2c.21-.03.41-.02.6.03l14.91 8.11c-.19-.05-.39-.06-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "m31.26 47.34-14.91-8.11c.1.02.19.06.27.1l14.91 8.11c-.09-.04-.18-.07-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "m31.53 47.44-14.91-8.11c.02.01.04.02.05.03l14.91 8.11c-.01-.01-.03-.02-.05-.03"
  }))), _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    d: "m29.72 50.9-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.04.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.08-1.74 2.12.01.66.33 1.2.81 1.47z"
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ai"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83243a",
    d: "m29.72 50.9-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.26.05-.51.13-.74l14.91 8.11c-.09.23-.13.48-.13.74.01.66.33 1.2.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86263c",
    d: "m29.05 48.69-14.91-8.11c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a283e",
    d: "m29.18 48.4-14.91-8.11c.04-.08.09-.16.14-.23l14.91 8.11c-.05.07-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d2940",
    d: "m29.32 48.17-14.91-8.11c.05-.07.1-.14.16-.2l14.91 8.11c-.06.06-.11.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#902b42",
    d: "m29.48 47.97-14.91-8.11c.06-.06.11-.12.18-.18l14.91 8.11c-.07.06-.13.12-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "m29.66 47.79-14.91-8.11c.07-.06.14-.12.21-.17l14.91 8.11c-.08.06-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "m29.87 47.63-14.91-8.11c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.09-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "m30.15 47.46-14.91-8.11c.16-.08.33-.13.51-.15l14.91 8.11c-.18.03-.35.08-.51.15"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#c03f5a",
    d: "M30.66 47.31c.96-.13 1.73.59 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63 0-1.04.78-1.99 1.74-2.12z"
  })), _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ak",
    d: "M7.16 43.86c.27.15.59.21.93.16 4.39 2.39 8.78 4.78 13.17 7.16l1.74.95c-.34.05-.66-.01-.93-.16-4.47-2.43-10.43-5.67-14.91-8.11z"
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ak"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M22.07 51.97 7.16 43.86c.02.01.04.02.05.03L22.13 52l-.06-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M22.13 52 7.22 43.89c.09.04.18.08.27.1L22.4 52.1c-.09-.02-.19-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M22.4 52.1 7.49 43.99c.19.05.39.06.6.03L23 52.13c-.21.03-.41.02-.6-.03"
  }))), _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "am",
    d: "M9.83 41.9c0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47 0 1.03-.78 1.98-1.74 2.12L8.09 44.02c.96-.13 1.74-1.08 1.74-2.12z"
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#am"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M23 52.13 8.09 44.02c.18-.02.35-.08.5-.15l14.91 8.11c-.16.08-.33.13-.5.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M23.5 51.98 8.59 43.87c.1-.05.19-.1.28-.16l14.91 8.11c-.08.06-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M23.79 51.82 8.88 43.71c.07-.05.14-.11.21-.17L24 51.65c-.07.06-.14.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M24 51.65 9.09 43.54l.18-.18 14.91 8.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M24.17 51.47 9.26 43.36c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M24.33 51.27 9.42 43.16c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M24.47 51.04 9.56 42.93c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M24.6 50.75 9.69 42.64c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.8-1.47l14.91 8.11c.48.26.81.8.8 1.47.01.25-.04.5-.13.73"
  }))), _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ao",
    d: "m9.02 40.43 14.91 8.11c-.27-.15-.59-.21-.93-.16L8.1 40.27c.34-.04.66.02.92.16z"
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ao"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M23.01 48.39 8.1 40.27c.21-.03.41-.02.6.03l14.91 8.11c-.19-.04-.39-.05-.6-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M23.61 48.42 8.7 40.31c.1.02.19.06.27.1l14.91 8.11a.987.987 0 0 0-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M23.88 48.52 8.97 40.41c.02.01.04.02.05.03l14.91 8.11c-.01-.01-.03-.02-.05-.03"
  }))), _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aq",
    d: "M22.07 51.97 7.16 43.86c-.49-.26-.81-.8-.81-1.47 0-1.04.78-1.98 1.74-2.12L23 48.38c-.96.13-1.74 1.08-1.74 2.12.01.67.33 1.21.81 1.47z"
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aq"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a8c8e",
    d: "M22.07 51.97 7.16 43.86c-.49-.26-.81-.8-.81-1.47 0-.26.05-.51.13-.74l14.91 8.11c-.09.23-.13.48-.13.74.01.67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e8f92",
    d: "M21.4 49.76 6.49 41.65c.04-.1.08-.2.13-.29l14.91 8.11c-.05.1-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929395",
    d: "M21.53 49.47 6.62 41.36c.04-.08.09-.16.14-.23l14.91 8.11c-.05.08-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959799",
    d: "M21.67 49.24 6.76 41.13c.05-.07.1-.14.16-.2l14.91 8.11a2.8 2.8 0 0 0-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999a9c",
    d: "M21.83 49.05 6.92 40.93c.06-.06.11-.12.18-.18l14.91 8.11c-.07.06-.13.12-.18.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M22.01 48.87 7.1 40.76c.07-.06.14-.12.21-.17l14.91 8.11c-.08.05-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M22.22 48.7 7.31 40.59c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M22.5 48.54 7.59 40.43c.16-.08.33-.13.51-.15l14.91 8.11c-.18.02-.35.07-.51.15"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcecf",
    d: "M23.01 48.39c.96-.13 1.73.59 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63 0-1.05.78-1.99 1.74-2.12z"
  })), _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "as",
    d: "M17.49 56.81 2.58 48.7c-.4-.22-.67-.66-.66-1.21l14.91 8.11c0 .54.26.99.66 1.21z"
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#as"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M17.49 56.81 2.58 48.7c-.4-.22-.67-.66-.66-1.21l14.91 8.11c0 .54.26.99.66 1.21"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#314d68",
    d: "M60.59 38.95c.79-.11 1.43.49 1.43 1.35L62 49.24c0 .86-.64 1.64-1.44 1.75L41 53.74l-3.18.45-19.56 2.75c-.8.11-1.44-.49-1.44-1.35l.02-8.94c0-.86.64-1.65 1.44-1.76l42.31-5.94zM30.65 51.06c.96-.13 1.74-1.09 1.74-2.12 0-1.04-.78-1.76-1.73-1.63-.96.13-1.74 1.08-1.74 2.12 0 1.03.77 1.76 1.73 1.63m7.65-1.08c.96-.13 1.74-1.09 1.74-2.12 0-1.04-.78-1.76-1.73-1.63-.96.13-1.74 1.08-1.74 2.12 0 1.03.77 1.77 1.73 1.63M23 52.13c.96-.13 1.74-1.09 1.74-2.12 0-1.04-.78-1.76-1.73-1.63-.96.13-1.74 1.08-1.74 2.12-.01 1.03.77 1.77 1.73 1.63m27.77-2.96.01-5.63c0-.44-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.05.74-.46.74-.9m3.63-.51.01-5.63c0-.44-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.05.74-.46.74-.9m-7.27 1.02.01-5.63c0-.44-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.05.74-.46.74-.9m10.9-1.53.01-5.63c0-.44-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.05.74-.46.74-.9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M57.3 41.82c.41-.06.74.26.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd9755",
    d: "M41 53.74v3.98l-3.18.45.01-3.98z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a445c",
    d: "M18.29 44.9 3.38 36.79l42.3-5.95 14.91 8.11z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "M16.83 55.59 1.92 47.48l.02-8.93 14.91 8.11z"
  })), _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "au",
    d: "M16.85 46.66 1.94 38.55c0-.86.64-1.65 1.44-1.76l14.91 8.11c-.8.11-1.44.89-1.44 1.76z"
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#au"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M16.85 46.66 1.94 38.55c0-.21.04-.42.11-.62l14.91 8.11c-.07.2-.11.4-.11.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M16.96 46.04 2.05 37.93c.03-.08.07-.16.11-.24l14.91 8.11c-.04.08-.08.16-.11.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M17.07 45.8 2.16 37.69c.04-.07.07-.13.12-.19l14.91 8.11a.76.76 0 0 0-.12.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M17.18 45.61 2.27 37.5c.04-.06.08-.11.13-.16l14.91 8.11c-.04.05-.09.1-.13.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M17.31 45.45 2.4 37.34c.05-.05.09-.1.15-.15l14.91 8.11c-.05.05-.1.09-.15.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M17.46 45.3 2.55 37.19c.06-.05.11-.1.17-.14l14.91 8.11c-.06.04-.12.09-.17.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M17.63 45.16 2.72 37.05c.07-.05.15-.1.23-.13l14.91 8.11c-.07.04-.15.08-.23.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M17.87 45.03 2.96 36.92c.13-.06.28-.11.42-.13l14.91 8.11c-.15.02-.29.06-.42.13"
  }))), _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aw",
    d: "M42.4 25.53c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aw"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m57.06 33.63-14.91-8.11c.08.02.16.03.25.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.01-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m57.53 33.58-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M57.65 33.51 42.74 25.4c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m57.74 33.44-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M57.81 33.36 42.9 25.25c.02-.03.05-.06.07-.09l14.91 8.11c-.02.03-.04.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m57.88 33.27-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m57.94 33.17-14.91-8.11c.02-.04.04-.08.06-.13L58 33.05l-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m58 33.05-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c-.01.1-.03.21-.06.31"
  }))), _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ay",
    d: "M42.01 25.46c.11.06.25.09.39.07 4.97 2.7 9.94 5.41 14.91 8.11a.638.638 0 0 1-.39-.07c-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ay"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m56.92 33.57-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m56.94 33.58-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m57.06 33.63-14.91-8.11c.08.02.16.03.25.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.01-.17.01-.25-.01"
  }))), _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    d: "m56.92 33.57-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63z"
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aA"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m56.92 33.57-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63"
  }))), _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    d: "m46.47 15.56 14.91 8.11c-.22-.12-.48-.17-.76-.13l-14.91-8.11c.28-.04.54.01.76.13z"
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aC"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m60.62 23.54-14.91-8.11c.17-.02.34-.01.49.03l14.91 8.11c-.15-.05-.32-.06-.49-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M61.11 23.56 46.2 15.45c.08.02.15.05.23.08l14.91 8.11c-.07-.03-.15-.06-.23-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m61.34 23.64-14.91-8.11c.01.01.03.01.04.02l14.91 8.11c-.01 0-.03-.01-.04-.02"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m58.05 32.74-14.91-8.11.02-5.64 14.91 8.11z"
  })), _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aE",
    d: "M38.77 26.04c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aE"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m53.43 34.14-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m53.9 34.09-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m54.02 34.02-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M54.11 33.95 39.2 25.83c.03-.02.05-.05.08-.08l14.91 8.11c-.03.04-.05.06-.08.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m54.18 33.87-14.91-8.11c.02-.03.05-.06.07-.09l14.91 8.11c-.02.03-.04.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m54.25 33.78-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11a.88.88 0 0 1-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M54.31 33.68 39.4 25.57c.02-.04.04-.08.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m54.37 33.56-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c0 .1-.02.21-.06.31"
  }))), _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aG",
    d: "M43.16 18.99c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.48-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aG"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m58.07 27.1-14.91-8.11c0-.29-.14-.51-.34-.63l14.91 8.11c.2.12.34.35.34.63"
  }))), _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    d: "M38.38 25.97c.11.06.25.09.4.07 4.97 2.7 9.94 5.41 14.91 8.11a.67.67 0 0 1-.4-.07c-4.47-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aI"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m53.29 34.08-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M53.31 34.09 38.4 25.98c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m53.43 34.14-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }))), _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aK",
    d: "m42.81 18.37 14.91 8.11a.656.656 0 0 0-.4-.07l-14.9-8.11c.14-.02.28 0 .39.07z"
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aK"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M57.33 26.41 42.42 18.3c.09-.01.18-.01.26.01l14.91 8.11a.758.758 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m57.58 26.42-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m57.7 26.46-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m56.57 32.95-14.91-8.12.02-5.63 14.91 8.11z"
  })), _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aM",
    d: "M56.59 27.31 41.68 19.2c0-.45.34-.85.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aM"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M56.59 27.31 41.68 19.2c0-.11.02-.22.06-.32L56.64 27c-.03.1-.05.2-.05.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m56.64 27-14.91-8.11c.02-.04.03-.08.06-.12l14.91 8.11c-.02.03-.04.07-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m56.7 26.87-14.91-8.11c.02-.03.04-.07.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m56.76 26.77-14.91-8.11a.27.27 0 0 1 .07-.08l14.91 8.11c-.03.03-.05.06-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "m56.82 26.69-14.91-8.11c.02-.03.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M56.9 26.61 41.99 18.5a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m56.99 26.54-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M57.11 26.47 42.2 18.36c.07-.03.14-.05.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M57.33 26.41c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aO",
    d: "m53.29 34.08-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63z"
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aP"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aO"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m53.29 34.08-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m54.43 33.25-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    d: "M35.15 26.55c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aR"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aQ"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m49.8 34.65-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.748.748 0 0 1-.47.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m50.27 34.6-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m50.39 34.53-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m50.48 34.46-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m50.56 34.38-14.91-8.11c.02-.03.05-.06.07-.09l14.91 8.11a.55.55 0 0 0-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m50.62 34.29-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.01.04-.03.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m50.68 34.19-14.91-8.11c.02-.04.04-.08.06-.13l14.91 8.11a.31.31 0 0 1-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m50.74 34.07-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c0 .1-.02.21-.06.31"
  }))), _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aS",
    d: "M39.53 19.5c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.48-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aT"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aS"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M54.44 27.61 39.53 19.5c0-.29-.14-.51-.34-.63l14.91 8.11c.2.12.34.35.34.63"
  }))), _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aU",
    d: "M34.75 26.48c.11.06.25.09.4.07 4.97 2.7 9.94 5.41 14.91 8.11a.67.67 0 0 1-.4-.07c-4.47-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aV"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aU"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m49.66 34.59-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m49.68 34.6-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m49.8 34.65-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.748.748 0 0 1-.47.05"
  }))), _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aW",
    d: "m39.18 18.88 14.91 8.11a.656.656 0 0 0-.4-.07l-14.91-8.11c.15-.02.29 0 .4.07z"
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aX"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aW"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m53.7 26.92-14.91-8.11c.09-.01.18-.01.26.01l14.91 8.11a.758.758 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m53.95 26.93-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.07-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m54.07 26.97-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m52.95 33.46-14.91-8.12.01-5.63 14.91 8.11z"
  })), _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "aY",
    d: "m52.96 27.82-14.91-8.11c0-.45.33-.84.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "aZ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#aY"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m52.96 27.82-14.91-8.11c0-.11.02-.22.06-.32l14.91 8.11c-.04.1-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M53.01 27.5 38.1 19.39c.02-.04.03-.08.06-.12l14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m53.07 27.38-14.91-8.11c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m53.13 27.28-14.91-8.11a.27.27 0 0 1 .07-.08L53.2 27.2c-.03.03-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "m53.19 27.2-14.91-8.11c.02-.03.05-.05.07-.08l14.91 8.11a.5.5 0 0 1-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m53.27 27.12-14.91-8.11a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.03-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m53.36 27.05-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m53.48 26.98-14.91-8.11c.07-.03.14-.06.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M53.7 26.92c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    d: "m49.66 34.59-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63z"
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ba"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.66 34.59-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m50.8 33.76-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bc",
    d: "M31.51 27.06c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.33.84-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bc"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.17 35.16-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.01-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M46.64 35.11 31.73 27c.04-.02.08-.04.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m46.76 35.04-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m46.85 34.97-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m46.92 34.89-14.91-8.11c.02-.03.05-.05.07-.08l14.91 8.11c-.02.03-.04.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M46.99 34.81 32.08 26.7c.02-.03.04-.06.06-.1l14.91 8.11c-.02.03-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M47.05 34.71 32.14 26.6l.06-.12 14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M47.11 34.58 32.2 26.47c.04-.1.06-.21.06-.32l14.91 8.11c-.01.12-.03.22-.06.32"
  }))), _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "be",
    d: "M35.9 20.01c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.47-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#be"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M50.81 28.12 35.9 20.01c0-.29-.14-.51-.34-.63l14.91 8.11c.2.12.34.35.34.63"
  }))), _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M31.12 26.99c.11.06.25.09.39.07 4.97 2.7 9.94 5.41 14.91 8.11a.638.638 0 0 1-.39-.07c-4.48-2.43-10.44-5.67-14.91-8.11z"
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bg"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m46.03 35.1-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M46.05 35.12 31.14 27c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.17 35.16-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.01-.17.01-.25-.01"
  }))), _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bi",
    d: "m35.56 19.39 14.91 8.11a.656.656 0 0 0-.4-.07l-14.91-8.11c.14-.02.28 0 .4.07z"
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bi"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m50.07 27.43-14.91-8.11c.09-.01.18-.01.26.01l14.91 8.11a.748.748 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m50.33 27.44-14.91-8.11c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m50.44 27.48-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m49.32 33.97-14.91-8.12.01-5.63 14.91 8.11z"
  })), _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    d: "m49.33 28.33-14.91-8.11c0-.45.33-.84.74-.9l14.91 8.11c-.41.06-.74.46-.74.9z"
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bk"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.33 28.33-14.91-8.11c0-.11.02-.22.06-.32l14.91 8.11c-.04.1-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M49.39 28.01 34.48 19.9c.02-.04.03-.08.06-.12l14.91 8.11c-.03.04-.05.08-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "m49.44 27.89-14.91-8.11c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "m49.5 27.79-14.91-8.11a.27.27 0 0 1 .07-.08l14.91 8.11a.5.5 0 0 0-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M49.57 27.71 34.66 19.6c.02-.03.05-.05.07-.08l14.91 8.11a.5.5 0 0 0-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "m49.64 27.63-14.91-8.11a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.03-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m49.73 27.56-14.91-8.11c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m49.85 27.49-14.91-8.11c.07-.03.14-.06.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bm",
    d: "m46.03 35.1-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63z"
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bm"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m46.03 35.1-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m47.16 34.27-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bo",
    d: "M32.26 20.52c0-.29-.13-.52-.34-.63L46.83 28c.21.11.34.34.34.63-4.47-2.43-10.43-5.67-14.91-8.11z"
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bo"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m47.17 28.63-14.91-8.11c0-.29-.13-.52-.34-.63L46.83 28c.21.12.34.35.34.63"
  }))), _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bq",
    d: "m31.92 19.9 14.91 8.11a.656.656 0 0 0-.4-.07l-14.91-8.11c.15-.02.29 0 .4.07z"
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bq"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m46.43 27.94-14.91-8.11c.09-.01.18-.01.26.01l14.91 8.11a.738.738 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m46.69 27.95-14.91-8.11c.04.01.08.02.12.04L46.81 28a.612.612 0 0 0-.12-.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M46.81 28 31.9 19.88c.01 0 .01.01.02.01L46.83 28h-.02"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m45.68 34.48-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bs",
    d: "m45.69 28.84-14.91-8.11c0-.45.34-.85.74-.9l14.91 8.11c-.4.06-.74.46-.74.9z"
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bs"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m45.69 28.84-14.91-8.11c0-.11.02-.22.06-.32l14.91 8.11c-.04.11-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m45.75 28.53-14.91-8.11c.02-.04.03-.08.06-.12l14.91 8.11c-.03.03-.04.07-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M45.81 28.4 30.9 20.29c.02-.03.04-.07.06-.1l14.91 8.11c-.03.04-.05.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M45.87 28.31 30.96 20.2a.27.27 0 0 1 .07-.08l14.91 8.11c-.03.02-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "m45.93 28.22-14.91-8.11c.02-.03.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M46.01 28.14 31.1 20.03a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.03-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "m46.1 28.07-14.91-8.11c.04-.03.08-.05.12-.07L46.22 28c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "m46.22 28-14.91-8.11c.07-.03.14-.05.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M46.43 27.94c.41-.06.74.25.74.69l-.01 5.63c0 .44-.33.84-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.34-.84.74-.9z"
  })), _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bu",
    d: "M22.49 26.29c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.43-10.43-5.67-14.91-8.11z"
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bu"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m37.4 34.4-14.91-8.11c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m37.46 34.43-14.91-8.11c.09.04.18.08.27.1l14.91 8.11c-.1-.02-.19-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m37.73 34.53-14.91-8.11c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.02-.6-.03"
  }))), _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bw",
    d: "M25.16 24.33c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12l-14.91-8.11c.95-.13 1.74-1.08 1.74-2.12z"
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bw"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m38.33 34.56-14.91-8.11c.18-.02.35-.08.51-.15l14.91 8.11c-.17.08-.34.13-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M38.83 34.41 23.92 26.3c.1-.05.19-.1.28-.16l14.91 8.11c-.08.06-.18.12-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m39.12 34.25-14.91-8.11c.07-.05.14-.11.21-.17l14.91 8.11c-.07.06-.14.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m39.33 34.08-14.91-8.11.18-.18 14.9 8.11c-.05.07-.11.13-.17.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m39.5 33.9-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m39.66 33.7-14.91-8.11c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m39.8 33.47-14.91-8.11c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m39.93 33.18-14.91-8.11c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47.01.25-.04.5-.13.73"
  }))), _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "by",
    d: "m24.35 22.86 14.91 8.11c-.27-.15-.59-.21-.93-.16L23.42 22.7c.35-.04.66.02.93.16z"
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bz"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#by"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "m38.34 30.82-14.91-8.11c.21-.03.41-.02.6.03l14.91 8.11c-.19-.05-.39-.06-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "m38.93 30.85-14.91-8.11c.1.02.19.06.27.1l14.91 8.11c-.08-.04-.17-.08-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "M39.21 30.95 24.3 22.84c.02.01.04.02.05.03l14.91 8.11c-.02-.01-.03-.02-.05-.03"
  }))), _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bA",
    d: "m37.4 34.4-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .67.33 1.21.81 1.47z"
  }))), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bB"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bA"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#557d74",
    d: "m37.4 34.4-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#578077",
    d: "m36.73 32.2-14.91-8.11c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a827a",
    d: "M36.86 31.91 21.95 23.8c.04-.08.09-.16.14-.23L37 31.68c-.05.07-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c857d",
    d: "m37 31.68-14.91-8.11c.05-.07.1-.14.16-.2l14.91 8.11c-.06.06-.11.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f8980",
    d: "m37.16 31.48-14.91-8.11.18-.18 14.91 8.11c-.06.05-.12.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "m37.34 31.3-14.91-8.11c.07-.06.14-.12.21-.17l14.91 8.11c-.08.05-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "m37.55 31.13-14.91-8.11c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "m37.83 30.97-14.91-8.11c.16-.08.33-.13.51-.15l14.91 8.11c-.18.02-.35.07-.51.15"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#80b5a7",
    d: "M38.34 30.82c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63 0-1.04.78-1.99 1.74-2.12z"
  })), _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bC",
    d: "M14.84 27.37c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.43-10.43-5.68-14.91-8.11z"
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bD"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bC"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m29.75 35.48-14.91-8.11c.02.01.04.02.05.03l14.91 8.11c-.01-.01-.03-.02-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M29.81 35.51 14.9 27.4c.09.04.18.08.27.1l14.91 8.11c-.1-.03-.19-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M30.08 35.61 15.17 27.5c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.02-.6-.03"
  }))), _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bE",
    d: "M17.51 25.41c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12l-14.91-8.11c.95-.14 1.74-1.09 1.74-2.12z"
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bF"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bE"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m30.68 35.64-14.91-8.11c.18-.02.35-.08.51-.15l14.91 8.11c-.17.07-.34.12-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m31.18 35.49-14.91-8.11c.1-.05.19-.1.28-.16l14.91 8.11c-.08.06-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m31.46 35.32-14.91-8.11c.07-.05.14-.11.21-.17l14.91 8.11a.87.87 0 0 1-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m31.68 35.16-14.91-8.11.18-.18 14.91 8.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m31.85 34.98-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M32.01 34.78 17.1 26.67c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m32.15 34.55-14.91-8.11c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m32.28 34.26-14.91-8.11c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47.01.24-.04.49-.13.73"
  }))), _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bG",
    d: "m16.7 23.94 14.91 8.11c-.27-.15-.59-.21-.93-.16l-14.91-8.11c.34-.05.66.01.93.16z"
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bH"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bG"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "m30.68 31.89-14.91-8.11c.21-.03.41-.02.6.03l14.91 8.11c-.18-.05-.39-.06-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "m31.28 31.92-14.91-8.11c.1.02.19.06.27.1l14.91 8.11c-.08-.04-.17-.07-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "m31.56 32.02-14.91-8.11c.02.01.04.02.05.03l14.91 8.11c-.02-.01-.04-.02-.05-.03"
  }))), _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bI",
    d: "m29.75 35.48-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .66.33 1.2.81 1.47z"
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bJ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bI"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83243a",
    d: "m29.75 35.48-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .66.33 1.2.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86263c",
    d: "m29.08 33.27-14.91-8.11c.04-.1.08-.2.13-.29l14.91 8.11c-.05.1-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a283e",
    d: "M29.21 32.98 14.3 24.87c.04-.08.09-.16.14-.23l14.91 8.11c-.05.07-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d2940",
    d: "m29.35 32.75-14.91-8.11c.05-.07.1-.14.16-.2l14.91 8.11a2.8 2.8 0 0 0-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#902b42",
    d: "M29.51 32.55 14.6 24.44l.18-.18 14.91 8.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "m29.69 32.37-14.91-8.11c.07-.06.14-.12.21-.17L29.9 32.2c-.08.06-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "M29.9 32.21 14.99 24.1c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.09-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "m30.18 32.04-14.91-8.11c.16-.08.33-.13.5-.15l14.91 8.11c-.17.03-.34.08-.5.15"
  }))), _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bK",
    d: "M7.19 28.44c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.43-10.43-5.67-14.91-8.11z"
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bL"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bK"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M22.1 36.55 7.19 28.44c.02.01.04.02.05.03l14.91 8.11c-.01-.01-.03-.02-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M22.16 36.58 7.25 28.47c.09.04.18.08.27.1l14.91 8.11c-.1-.02-.19-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M22.43 36.68 7.52 28.57c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.02-.6-.03"
  }))), _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bM",
    d: "M9.86 26.49c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12L8.12 28.6c.95-.13 1.73-1.08 1.74-2.11z"
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bN"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bM"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M23.03 36.71 8.12 28.6c.18-.02.35-.08.51-.15l14.91 8.11c-.17.08-.34.13-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M23.53 36.56 8.62 28.45c.1-.05.19-.1.28-.16l14.91 8.11c-.09.06-.18.12-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M23.81 36.4 8.9 28.29c.07-.05.14-.11.21-.17l14.91 8.11c-.06.06-.13.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M24.02 36.23 9.11 28.12l.18-.18 14.91 8.11c-.05.07-.11.13-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M24.2 36.05 9.29 27.94c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M24.36 35.85 9.45 27.74c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M24.5 35.62 9.59 27.51c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M24.63 35.33 9.72 27.22c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47.01.25-.04.5-.13.73"
  }))), _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bO",
    d: "m9.05 25.02 14.91 8.11c-.27-.15-.59-.21-.93-.16L8.12 24.86c.34-.05.66.01.93.16z"
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bP"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bO"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M23.03 32.97 8.12 24.86c.21-.03.41-.02.6.03L23.63 33c-.18-.05-.39-.06-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M23.63 33 8.72 24.89c.1.02.19.06.27.1L23.9 33.1c-.08-.04-.17-.08-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M23.91 33.1 9 24.99c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 1-.05-.03"
  }))), _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bQ",
    d: "M22.1 36.55 7.19 28.44c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .67.33 1.21.81 1.47z"
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bR"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bQ"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a8c8e",
    d: "M22.1 36.55 7.19 28.44c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e8f92",
    d: "M21.43 34.35 6.52 26.24c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929395",
    d: "M21.56 34.06 6.65 25.95c.04-.08.09-.16.14-.23l14.91 8.11c-.05.07-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959799",
    d: "M21.7 33.83 6.79 25.72c.05-.07.1-.14.16-.2l14.91 8.11c-.06.06-.11.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999a9c",
    d: "M21.86 33.63 6.95 25.52l.18-.18 14.91 8.11c-.07.05-.12.11-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M22.04 33.45 7.13 25.34c.07-.06.14-.12.21-.17l14.91 8.11c-.08.05-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M22.25 33.28 7.34 25.17c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M22.53 33.12 7.62 25.01c.16-.08.33-.13.5-.15l14.91 8.11c-.17.02-.34.07-.5.15"
  }))), _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bS",
    d: "M17.52 41.4 2.61 33.28c-.4-.22-.67-.67-.67-1.22l14.91 8.11c.01.56.27 1.01.67 1.23z"
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bT"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bS"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M17.52 41.4 2.61 33.28c-.4-.22-.67-.67-.67-1.22l14.91 8.11c.01.56.27 1.01.67 1.23"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#314d68",
    d: "M60.62 23.54c.79-.11 1.43.5 1.43 1.35l-.02 8.94c0 .86-.64 1.65-1.44 1.76l-42.3 5.94c-.8.11-1.44-.49-1.44-1.35l.02-8.94c0-.86.64-1.65 1.44-1.76l42.31-5.94zm-29.94 12.1c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.03.77 1.76 1.73 1.63m7.65-1.08c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.04.77 1.77 1.73 1.63m-15.3 2.15c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.04.77 1.77 1.73 1.63m27.77-2.95.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.06.74-.46.74-.9m3.63-.51.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.06.74-.46.74-.9m-7.27 1.02.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.06.74-.46.74-.9m10.89-1.53.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.06.74-.46.74-.9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M50.07 27.43c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.33-.84.74-.9z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#c03f5a",
    d: "M30.68 31.89c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63.01-1.03.79-1.98 1.74-2.12z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcecf",
    d: "M23.03 32.97c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63.01-1.04.79-1.99 1.74-2.12z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a445c",
    d: "M18.32 29.48 3.41 21.37l42.3-5.95 14.91 8.12z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "M16.86 40.17 1.95 32.06l.02-8.93 14.91 8.11z"
  })), _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bU",
    d: "M16.88 31.24 1.97 23.13c0-.86.64-1.65 1.44-1.76l14.91 8.11c-.8.11-1.44.9-1.44 1.76z"
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bV"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bU"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M16.88 31.24 1.97 23.13c0-.21.04-.42.11-.61l14.91 8.11c-.07.19-.11.4-.11.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M16.99 30.63 2.08 22.52c.03-.08.07-.16.11-.24l14.91 8.11a.88.88 0 0 0-.11.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M17.1 30.38 2.19 22.27c.04-.07.07-.13.12-.19l14.91 8.11c-.05.06-.09.13-.12.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M17.21 30.19 2.3 22.08c.04-.06.08-.11.13-.16l14.91 8.11-.13.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M17.34 30.03 2.43 21.92l.15-.15 14.91 8.11-.15.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M17.49 29.88 2.58 21.77c.06-.05.11-.1.17-.14l14.91 8.11c-.06.04-.11.09-.17.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M17.66 29.74 2.75 21.63c.07-.05.15-.1.23-.13l14.91 8.11c-.07.04-.15.08-.23.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M17.9 29.61 2.99 21.5c.13-.06.27-.11.42-.13l14.91 8.11c-.15.02-.29.06-.42.13"
  }))), _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bW",
    d: "M42.43 10.12c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bX"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bW"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m57.09 18.22-14.91-8.11c.08.02.16.03.25.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.01-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m57.56 18.16-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.06-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M57.68 18.1 42.77 9.98c.03-.02.06-.05.09-.07l14.91 8.11c-.03.03-.06.05-.09.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M57.77 18.02 42.86 9.91c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M57.84 17.95 42.93 9.84c.02-.03.05-.06.07-.09l14.91 8.11a.55.55 0 0 1-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M57.91 17.86 43 9.75c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M57.97 17.76 43.06 9.65c.02-.04.04-.08.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M58.03 17.64 43.12 9.53c.04-.1.06-.2.06-.31l14.91 8.11c-.01.1-.03.21-.06.31"
  }))), _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bY",
    d: "M42.04 10.05c.11.06.25.09.39.07 4.97 2.7 9.94 5.41 14.91 8.11a.638.638 0 0 1-.39-.07c-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath78 || (_clipPath78 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bZ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#bY"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m56.95 18.16-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11c-.01 0-.01-.01-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m56.97 18.17-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m57.09 18.22-14.91-8.11c.08.02.16.03.25.01.07-.01.15-.03.21-.06l14.91 8.11a.83.83 0 0 1-.21.06c-.09.01-.17.01-.25-.01"
  }))), _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ca",
    d: "m56.95 18.16-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63z"
  }))), _clipPath79 || (_clipPath79 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cb"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ca"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m56.95 18.16-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63"
  }))), _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cc",
    d: "m46.5.14 14.91 8.11c-.22-.12-.48-.17-.76-.13L45.74.01c.28-.04.54.01.76.13z"
  }))), _clipPath80 || (_clipPath80 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cc"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M60.65 8.12 45.74.01c.17-.02.34-.01.49.03l14.91 8.11c-.15-.04-.32-.05-.49-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M61.14 8.15 46.23.04c.08.02.15.05.23.08l14.91 8.11c-.08-.03-.15-.06-.23-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M61.37 8.23 46.46.12c.01.01.03.01.04.02l14.91 8.11c-.01 0-.03-.01-.04-.02"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "M58.08 17.33 43.17 9.22l.01-5.64 14.91 8.11z"
  })), _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ce",
    d: "M38.8 10.63c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath81 || (_clipPath81 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cf"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ce"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m53.46 18.73-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m53.93 18.67-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.06-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M54.05 18.61 39.14 10.5c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.04-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m54.14 18.53-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M54.21 18.46 39.3 10.35c.02-.03.05-.06.07-.09l14.91 8.11c-.02.03-.04.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m54.28 18.37-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m54.34 18.27-14.91-8.11c.02-.04.04-.08.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m54.4 18.15-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c-.01.1-.03.21-.06.31"
  }))), _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cg",
    d: "M43.18 3.58c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.47-2.43-10.43-5.68-14.91-8.11z"
  }))), _clipPath82 || (_clipPath82 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cg"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M58.09 11.69 43.18 3.58c0-.29-.14-.51-.34-.63l14.91 8.11c.21.12.34.35.34.63"
  }))), _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ci",
    d: "M38.41 10.56c.11.06.25.09.4.07 4.97 2.7 9.94 5.41 14.91 8.11a.67.67 0 0 1-.4-.07c-4.48-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath83 || (_clipPath83 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ci"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m53.32 18.67-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11c-.01 0-.02 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m53.34 18.68-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m53.46 18.73-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }))), _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ck",
    d: "m42.84 2.95 14.91 8.11c-.11-.06-.25-.08-.39-.06L42.45 2.89c.14-.02.28 0 .39.06z"
  }))), _clipPath84 || (_clipPath84 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ck"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M57.36 11 42.45 2.89c.09-.01.18-.01.26.01l14.91 8.11a.572.572 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M57.61 11.01 42.7 2.9c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M57.73 11.05 42.82 2.94c.01 0 .02.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "M56.6 17.53 41.69 9.42l.01-5.63 14.91 8.11z"
  })), _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cm",
    d: "M56.61 11.9 41.7 3.79c0-.45.34-.85.74-.9L57.36 11c-.41.05-.75.45-.75.9z"
  }))), _clipPath85 || (_clipPath85 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cn"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cm"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M56.61 11.9 41.7 3.79c0-.11.02-.22.06-.32l14.91 8.11c-.04.1-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M56.67 11.58 41.76 3.47c.02-.04.03-.08.06-.12l14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M56.73 11.46 41.82 3.35c.02-.03.04-.07.06-.1l14.91 8.11c-.03.03-.05.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M56.79 11.36 41.88 3.25a.27.27 0 0 1 .07-.08l14.91 8.11a.5.5 0 0 0-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M56.85 11.28 41.94 3.17c.02-.03.05-.05.08-.08l14.91 8.11-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M56.93 11.2 42.02 3.09a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M57.02 11.13 42.11 3.02c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M57.14 11.06 42.23 2.95c.07-.03.14-.05.22-.07L57.36 11c-.08.01-.15.03-.22.06"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M57.36 11c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c-.01-.45.33-.85.74-.9z"
  })), _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "co",
    d: "m53.32 18.67-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c-.01.29.13.52.34.63z"
  }))), _clipPath86 || (_clipPath86 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#co"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m53.32 18.67-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c-.01.29.13.52.34.63"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "M54.45 17.84 39.54 9.73l.02-5.64 14.91 8.11z"
  })), _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cq",
    d: "M35.17 11.14c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.34.85-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath87 || (_clipPath87 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cq"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m49.83 19.24-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m50.3 19.18-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.06-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M50.42 19.12 35.51 11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.03-.06.05-.09.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M50.51 19.04 35.6 10.93c.03-.02.05-.05.08-.08l14.91 8.11c-.03.03-.05.06-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m50.58 18.97-14.91-8.11c.02-.03.05-.06.07-.09l14.91 8.11c-.02.03-.04.06-.07.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m50.65 18.88-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11a.88.88 0 0 1-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M50.71 18.78 35.8 10.67c.02-.04.04-.08.06-.13l14.91 8.11c-.02.05-.04.09-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m50.77 18.66-14.91-8.11c.04-.1.06-.2.06-.31l14.91 8.11c0 .1-.02.21-.06.31"
  }))), _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cs",
    d: "M39.56 4.09c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.48-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath88 || (_clipPath88 = /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cs"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M54.47 12.2 39.56 4.09c0-.29-.14-.51-.34-.63l14.91 8.11c.2.12.34.35.34.63"
  }))), _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cu",
    d: "M34.78 11.07c.11.06.25.09.4.07 4.97 2.7 9.94 5.41 14.91 8.11a.67.67 0 0 1-.4-.07c-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath89 || (_clipPath89 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cu"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m49.69 19.18-14.91-8.11c.01 0 .01.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M49.71 19.19 34.8 11.08c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m49.83 19.24-14.91-8.11c.08.02.17.03.26.01.07-.01.15-.03.21-.06l14.91 8.11a.738.738 0 0 1-.47.05"
  }))), _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cw",
    d: "m39.21 3.46 14.91 8.11a.656.656 0 0 0-.4-.07l-14.9-8.1c.14-.02.28 0 .39.06z"
  }))), _clipPath90 || (_clipPath90 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cw"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M53.73 11.51 38.82 3.4c.09-.01.18-.01.26.01l14.91 8.11a.572.572 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M53.98 11.52 39.07 3.41c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M54.1 11.56 39.19 3.45c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "M52.97 18.04 38.06 9.93l.01-5.63 14.92 8.11z"
  })), _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cy",
    d: "M52.99 12.41 38.07 4.3c0-.45.33-.84.74-.9l14.91 8.11c-.41.05-.73.45-.73.9z"
  }))), _clipPath91 || (_clipPath91 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cy"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M52.99 12.41 38.07 4.3c0-.11.02-.22.06-.32l14.91 8.11c-.03.1-.05.21-.05.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M53.04 12.09 38.13 3.98c.02-.04.03-.08.06-.12l14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M53.1 11.97 38.19 3.86c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.06-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M53.16 11.87 38.25 3.76a.27.27 0 0 1 .07-.08l14.91 8.11c-.03.02-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M53.22 11.79 38.31 3.68c.02-.03.05-.05.07-.08l14.91 8.11c-.02.03-.04.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M53.3 11.71 38.39 3.6a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M53.39 11.64 38.48 3.53c.04-.03.08-.05.12-.07l14.91 8.11c-.05.02-.09.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M53.51 11.57 38.6 3.46c.07-.03.14-.06.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M53.73 11.51c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.45.32-.85.74-.9z"
  })), _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cA",
    d: "m49.69 19.18-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63z"
  }))), _clipPath92 || (_clipPath92 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cB"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cA"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cB)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m49.69 19.18-14.91-8.11c-.21-.11-.34-.34-.34-.63l14.91 8.11c0 .29.13.52.34.63"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m50.83 18.35-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cC",
    d: "M31.54 11.65c.41-.06.74-.46.74-.9l14.91 8.11c0 .44-.33.84-.74.9-4.97-2.7-9.94-5.41-14.91-8.11z"
  }))), _clipPath93 || (_clipPath93 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cD"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cC"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cD)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.2 19.75-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.01-.17.01-.25-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m46.67 19.69-14.91-8.11c.04-.02.08-.04.12-.07l14.91 8.11c-.04.03-.08.06-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m46.79 19.63-14.91-8.11c.03-.02.06-.05.09-.07l14.91 8.11c-.03.02-.06.04-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m46.88 19.55-14.91-8.11c.03-.02.05-.05.08-.08l14.91 8.11c-.03.04-.06.06-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m46.95 19.48-14.91-8.11c.02-.03.05-.05.07-.08l14.91 8.11c-.02.02-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m47.02 19.39-14.91-8.11c.02-.03.04-.06.06-.1l14.91 8.11c-.02.04-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m47.08 19.3-14.91-8.11.06-.12 14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "m47.13 19.17-14.91-8.11c.04-.1.06-.21.06-.32l14.91 8.11c0 .12-.02.22-.06.32"
  }))), _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cE",
    d: "M35.93 4.6c0-.29-.14-.51-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.48-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath94 || (_clipPath94 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cF"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cE"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cF)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M50.84 12.71 35.93 4.6c0-.29-.14-.51-.34-.63l14.91 8.11c.2.12.34.35.34.63"
  }))), _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cG",
    d: "M31.15 11.58c.11.06.25.09.39.07 4.97 2.7 9.94 5.41 14.91 8.11a.638.638 0 0 1-.39-.07c-4.48-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath95 || (_clipPath95 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cH"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cG"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cH)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m46.06 19.69-14.91-8.11c.01 0 .02.01.02.01l14.91 8.11c-.01 0-.02 0-.02-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m46.08 19.7-14.91-8.11c.04.02.08.03.12.04l14.91 8.11c-.04 0-.08-.02-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m46.2 19.75-14.91-8.11c.08.02.16.03.25.01.08-.01.15-.03.22-.07l14.91 8.11c-.07.03-.14.05-.22.07-.09.01-.17.01-.25-.01"
  }))), _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cI",
    d: "m35.58 3.97 14.91 8.11a.656.656 0 0 0-.4-.07l-14.9-8.1c.14-.02.28 0 .39.06z"
  }))), _clipPath96 || (_clipPath96 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cJ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cI"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cJ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M50.1 12.02 35.19 3.91c.09-.01.18-.01.26.01l14.91 8.11a.572.572 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M50.35 12.03 35.44 3.92c.04.01.08.03.12.04l14.91 8.11c-.04-.01-.07-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M50.47 12.07 35.56 3.96c.01 0 .02.01.02.01l14.91 8.11s-.01 0-.02-.01"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "m49.35 18.55-14.91-8.11.01-5.63 14.91 8.11z"
  })), _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cK",
    d: "M49.36 12.92 34.45 4.81c0-.45.33-.84.74-.9l14.91 8.11c-.41.05-.74.45-.74.9z"
  }))), _clipPath97 || (_clipPath97 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cL"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cK"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cL)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M49.36 12.92 34.45 4.81c0-.11.02-.22.06-.32l14.91 8.11c-.04.1-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M49.41 12.6 34.5 4.49c.02-.04.03-.08.06-.12l14.91 8.11-.06.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M49.47 12.48 34.56 4.37c.02-.03.04-.07.06-.1l14.91 8.11a.88.88 0 0 0-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M49.53 12.38 34.62 4.27a.27.27 0 0 1 .07-.08L49.6 12.3a.27.27 0 0 0-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M49.59 12.3 34.68 4.19c.02-.03.05-.05.07-.08l14.91 8.11c-.02.03-.04.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M49.67 12.22 34.76 4.11a.55.55 0 0 1 .09-.07l14.91 8.11c-.03.02-.06.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M49.76 12.15 34.85 4.04c.04-.03.08-.05.12-.07l14.91 8.11c-.04.02-.08.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M49.88 12.08 34.97 3.97c.07-.03.14-.06.22-.07l14.91 8.11c-.08.02-.15.04-.22.07"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M50.1 12.02c.41-.06.74.25.74.69l-.01 5.63c0 .44-.34.85-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.45.33-.85.74-.9z"
  })), _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cM",
    d: "m46.06 19.69-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63z"
  }))), _clipPath98 || (_clipPath98 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cN"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cM"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cN)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "m46.06 19.69-14.91-8.11c-.21-.11-.35-.34-.35-.63l14.91 8.11c0 .29.14.52.35.63"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "m47.19 18.86-14.91-8.11.01-5.64 14.91 8.11z"
  })), _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cO",
    d: "M32.29 5.11c0-.29-.13-.52-.34-.63l14.91 8.11c.21.11.34.34.34.63-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath99 || (_clipPath99 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cP"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cO"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cP)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M47.2 13.22 32.29 5.11c0-.29-.13-.52-.34-.63l14.91 8.11c.21.12.34.35.34.63"
  }))), _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cQ",
    d: "m31.95 4.48 14.91 8.11a.656.656 0 0 0-.4-.07l-14.91-8.1c.15-.02.29 0 .4.06z"
  }))), _clipPath100 || (_clipPath100 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cR"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cQ"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cR)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M46.46 12.53 31.55 4.42c.09-.01.18-.01.26.01l14.91 8.11a.566.566 0 0 0-.26-.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M46.72 12.54 31.81 4.43c.04.01.08.02.12.04l14.91 8.11c-.04-.01-.08-.03-.12-.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M46.84 12.58 31.93 4.47c.01 0 .01.01.02.01l14.91 8.11c-.01 0-.01 0-.02-.01"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#1c354a",
    d: "M45.71 19.07 30.8 10.95l.01-5.63 14.91 8.11z"
  })), _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cS",
    d: "M45.72 13.43 30.81 5.32c0-.45.34-.85.74-.9l14.91 8.11c-.4.05-.74.46-.74.9z"
  }))), _clipPath101 || (_clipPath101 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cT"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cS"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cT)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M45.72 13.43 30.81 5.32c0-.11.02-.22.06-.32l14.91 8.11c-.04.1-.06.21-.06.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d364b",
    d: "M45.78 13.12 30.87 5c.02-.04.03-.08.06-.12l14.91 8.11a.31.31 0 0 0-.06.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e384d",
    d: "M45.83 12.99 30.92 4.88c.02-.03.04-.07.06-.1l14.91 8.11c-.02.03-.04.07-.06.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f384d",
    d: "M45.89 12.89 30.98 4.78c.02-.03.05-.05.07-.08l14.91 8.11c-.02.03-.05.05-.07.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20394f",
    d: "M45.96 12.81 31.05 4.7c.02-.03.05-.05.08-.08l14.91 8.11c-.03.03-.06.05-.08.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#203a50",
    d: "M46.04 12.73 31.13 4.62a.55.55 0 0 1 .09-.07l14.91 8.11c-.04.02-.07.05-.09.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#213b51",
    d: "M46.13 12.66 31.22 4.55c.04-.03.08-.05.12-.07l14.91 8.11c-.05.02-.09.05-.12.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223c52",
    d: "M46.25 12.59 31.34 4.48c.07-.03.14-.05.22-.07l14.91 8.11c-.08.02-.16.04-.22.07"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#29455d",
    d: "M46.46 12.53c.41-.06.74.25.74.69l-.01 5.63c0 .44-.33.84-.74.9-.41.06-.74-.26-.74-.69l.01-5.63c0-.44.34-.85.74-.9z"
  })), _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cU",
    d: "M22.52 10.88c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath102 || (_clipPath102 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cV"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cU"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cV)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m37.43 18.99-14.91-8.11c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m37.48 19.02-14.91-8.11c.09.04.18.08.27.1l14.91 8.11c-.09-.02-.18-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m37.76 19.12-14.91-8.11c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.02-.6-.03"
  }))), _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cW",
    d: "M25.19 8.92c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12l-14.91-8.11c.95-.13 1.73-1.08 1.74-2.12z"
  }))), _clipPath103 || (_clipPath103 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cX"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cW"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cX)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "m38.36 19.15-14.91-8.11c.18-.02.35-.08.5-.15L38.86 19c-.16.07-.33.13-.5.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m38.86 19-14.91-8.11c.1-.05.19-.1.28-.16l14.91 8.11c-.09.06-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m39.14 18.84-14.91-8.11c.07-.05.14-.11.21-.17l14.91 8.11c-.06.06-.13.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m39.35 18.67-14.91-8.11.18-.18 14.91 8.11c-.05.06-.11.12-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m39.53 18.49-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m39.69 18.29-14.91-8.11c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M39.83 18.06 24.92 9.95c.05-.09.09-.19.13-.29l14.91 8.11c-.03.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M39.96 17.77 25.05 9.66c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47.01.25-.04.5-.13.73"
  }))), _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cY",
    d: "m24.38 7.45 14.91 8.11c-.27-.15-.59-.21-.93-.16L23.45 7.29c.34-.04.66.02.93.16z"
  }))), _clipPath104 || (_clipPath104 = /*#__PURE__*/React.createElement("clipPath", {
    id: "cZ"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#cY"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cZ)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "M38.36 15.4 23.45 7.29c.21-.03.41-.02.6.03l14.91 8.11c-.18-.04-.39-.05-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "M38.96 15.44 24.05 7.32c.1.02.19.06.27.1l14.91 8.11a1.07 1.07 0 0 0-.27-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "M39.24 15.54 24.33 7.43c.02.01.04.02.05.03l14.91 8.11c-.02-.02-.04-.02-.05-.03"
  }))), _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "da",
    d: "m37.43 18.99-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .67.33 1.21.81 1.47z"
  }))), _clipPath105 || (_clipPath105 = /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#da"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#557d74",
    d: "m37.43 18.99-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#578077",
    d: "M36.76 16.79 21.85 8.68c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.09.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5a827a",
    d: "M36.89 16.49 21.98 8.38c.04-.08.09-.16.14-.23l14.91 8.11c-.05.08-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c857d",
    d: "M37.03 16.26 22.12 8.15c.05-.07.1-.14.16-.2l14.91 8.11c-.06.07-.11.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5f8980",
    d: "M37.19 16.07 22.28 7.95l.18-.18 14.91 8.11c-.07.06-.13.12-.18.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#618c82",
    d: "M37.37 15.89 22.46 7.77c.07-.06.14-.12.21-.17l14.91 8.11c-.08.06-.15.12-.21.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#648f85",
    d: "M37.58 15.72 22.67 7.61c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#669288",
    d: "M37.86 15.56 22.95 7.45c.16-.08.33-.13.51-.15l14.91 8.11c-.18.02-.35.07-.51.15"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#80b5a7",
    d: "M38.36 15.4c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63.01-1.03.79-1.98 1.74-2.12z"
  })), _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dc",
    d: "M14.87 11.96c.27.15.59.21.93.16l14.91 8.11c-.34.05-.66-.01-.93-.16-4.47-2.44-10.44-5.68-14.91-8.11z"
  }))), _clipPath106 || (_clipPath106 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#dc"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "m29.78 20.07-14.91-8.11c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "m29.83 20.09-14.91-8.11c.09.04.18.08.27.1l14.91 8.11a.987.987 0 0 1-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M30.11 20.2 15.2 12.09c.19.05.39.06.6.03l14.91 8.11c-.21.03-.41.01-.6-.03"
  }))), _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "de",
    d: "M17.54 10c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12L15.8 12.12c.95-.14 1.73-1.09 1.74-2.12z"
  }))), _clipPath107 || (_clipPath107 = /*#__PURE__*/React.createElement("clipPath", {
    id: "df"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#de"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M30.71 20.23 15.8 12.12c.18-.02.35-.08.51-.15l14.91 8.11c-.17.07-.34.12-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M31.21 20.07 16.3 11.96c.1-.05.19-.1.28-.16l14.91 8.11c-.09.06-.18.12-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M31.49 19.91 16.58 11.8c.07-.05.14-.11.21-.17l14.91 8.11a.87.87 0 0 1-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "m31.7 19.75-14.91-8.11.18-.18 14.91 8.11c-.05.06-.11.12-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "m31.88 19.57-14.91-8.11c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "m32.04 19.37-14.91-8.11c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "m32.18 19.14-14.91-8.11c.05-.09.09-.19.13-.29l14.91 8.11c-.03.09-.08.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M32.31 18.84 17.4 10.73c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47.01.25-.04.5-.13.73"
  }))), _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dg",
    d: "m16.73 8.53 14.91 8.11c-.27-.15-.59-.21-.93-.16L15.8 8.37c.34-.05.66.01.93.16z"
  }))), _clipPath108 || (_clipPath108 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dh"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#dg"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dh)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "M30.71 16.48 15.8 8.37c.21-.03.41-.02.6.03l14.91 8.11c-.19-.05-.39-.06-.6-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "M31.31 16.51 16.4 8.4c.1.02.19.06.27.1l14.91 8.11c-.08-.04-.17-.07-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "M31.59 16.61 16.68 8.5c.02.01.04.02.05.03l14.91 8.11c-.02-.01-.04-.02-.05-.03"
  }))), _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "di",
    d: "m29.78 20.07-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .66.33 1.2.81 1.47z"
  }))), _clipPath109 || (_clipPath109 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#di"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dj)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83243a",
    d: "m29.78 20.07-14.91-8.11c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .66.33 1.2.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#86263c",
    d: "M29.11 17.86 14.2 9.75c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.1.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a283e",
    d: "M29.24 17.57 14.33 9.46c.04-.08.09-.16.14-.23l14.91 8.11c-.05.07-.1.15-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d2940",
    d: "M29.38 17.34 14.47 9.23c.05-.07.1-.14.16-.2l14.91 8.11c-.06.06-.11.13-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#902b42",
    d: "M29.54 17.14 14.63 9.03l.18-.18 14.91 8.11c-.07.06-.13.12-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#942c44",
    d: "M29.72 16.96 14.81 8.85c.07-.06.14-.12.21-.17l14.91 8.11c-.08.06-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#972e45",
    d: "M29.93 16.79 15.02 8.68c.09-.06.18-.12.28-.16l14.91 8.11c-.1.05-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9b2f47",
    d: "M30.21 16.63 15.3 8.52c.16-.08.33-.13.5-.15l14.91 8.11c-.17.02-.34.08-.5.15"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#c03f5a",
    d: "M30.71 16.48c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63.01-1.03.79-1.99 1.74-2.12z"
  })), _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dk",
    d: "M7.22 13.03c.27.15.59.21.93.16 4.39 2.39 8.78 4.78 13.17 7.16l1.74.95c-.34.05-.66-.01-.93-.16-4.47-2.43-10.44-5.68-14.91-8.11z"
  }))), _clipPath110 || (_clipPath110 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#dk"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dl)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M22.13 21.14 7.22 13.03c.02.01.04.02.05.03l14.91 8.11a.219.219 0 0 0-.05-.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M22.18 21.17 7.27 13.06c.09.04.18.08.27.1l14.91 8.11c-.09-.02-.18-.06-.27-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M22.46 21.27 7.55 13.16c.19.05.39.06.6.03l14.91 8.11c-.21.03-.42.02-.6-.03"
  }))), _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dm",
    d: "M9.89 11.07c0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 1.03-.78 1.98-1.74 2.12L8.15 13.19c.95-.13 1.73-1.08 1.74-2.12z"
  }))), _clipPath111 || (_clipPath111 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dn"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#dm"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M23.06 21.3 8.15 13.19c.18-.02.35-.08.51-.15l14.91 8.11c-.17.08-.34.13-.51.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M23.56 21.15 8.65 13.04c.1-.05.19-.1.28-.16l14.91 8.11c-.09.06-.18.11-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M23.84 20.99 8.93 12.88c.07-.05.14-.11.21-.17l14.91 8.11c-.06.06-.13.12-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M24.05 20.82 9.14 12.71l.18-.18 14.91 8.11c-.05.06-.11.12-.18.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M24.23 20.64 9.32 12.53c.06-.06.11-.13.16-.2l14.91 8.11c-.05.07-.1.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M24.39 20.44 9.48 12.33c.05-.07.1-.15.14-.23l14.91 8.11c-.04.08-.09.16-.14.23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M24.53 20.21 9.62 12.1c.05-.09.09-.19.13-.29l14.91 8.11c-.04.1-.08.2-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M24.66 19.92 9.75 11.81c.09-.23.13-.48.13-.73 0-.67-.32-1.21-.81-1.47l14.91 8.11c.49.26.81.8.81 1.47 0 .25-.04.5-.13.73"
  }))), _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "do",
    d: "m9.08 9.6 14.91 8.11c-.27-.15-.59-.21-.93-.16L8.15 9.44c.34-.04.66.02.93.16z"
  }))), _clipPath112 || (_clipPath112 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dp"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#do"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dp)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M23.06 17.56 8.15 9.44c.21-.03.41-.02.6.03l14.91 8.11c-.19-.04-.39-.05-.6-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M23.66 17.59 8.75 9.47c.1.02.19.06.27.1l14.91 8.11a1.07 1.07 0 0 0-.27-.09"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M23.94 17.69 9.03 9.58c.01.01.03.01.05.02l14.91 8.11c-.02 0-.04-.01-.05-.02"
  }))), _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dq",
    d: "M22.13 21.14 7.22 13.03c-.49-.26-.81-.8-.81-1.47 0-1.03.78-1.98 1.74-2.12l14.91 8.11c-.96.13-1.74 1.09-1.74 2.12 0 .67.33 1.21.81 1.47z"
  }))), _clipPath113 || (_clipPath113 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#dq"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dr)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a8c8e",
    d: "M22.13 21.14 7.22 13.03c-.49-.26-.81-.8-.81-1.47 0-.25.05-.5.13-.73l14.91 8.11c-.09.23-.13.48-.13.73 0 .67.33 1.21.81 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8e8f92",
    d: "M21.46 18.94 6.55 10.83c.04-.1.08-.2.13-.29l14.91 8.11c-.05.09-.1.19-.13.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#929395",
    d: "M21.59 18.65 6.68 10.53c.04-.08.09-.16.14-.23l14.91 8.11c-.05.08-.1.16-.14.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#959799",
    d: "M21.73 18.41 6.82 10.3c.05-.07.1-.14.16-.2l14.91 8.11c-.06.07-.11.14-.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999a9c",
    d: "M21.89 18.22 6.98 10.1l.18-.18 14.91 8.11c-.07.06-.13.12-.18.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d9ea0",
    d: "M22.07 18.04 7.16 9.93c.07-.06.14-.12.21-.17l14.91 8.11c-.08.05-.15.11-.21.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a0a2a4",
    d: "M22.28 17.87 7.37 9.76c.09-.06.18-.12.28-.16l14.91 8.11c-.1.04-.19.1-.28.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4a5a7",
    d: "M22.56 17.71 7.65 9.6c.16-.08.33-.13.5-.15l14.91 8.11c-.17.02-.34.07-.5.15"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcecf",
    d: "M23.06 17.56c.96-.13 1.73.6 1.73 1.63 0 1.03-.78 1.98-1.74 2.12-.96.13-1.73-.6-1.73-1.63.01-1.04.79-1.99 1.74-2.12z"
  })), _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ds",
    d: "M17.55 25.98 2.64 17.87c-.4-.22-.67-.67-.67-1.22l14.91 8.11c.01.56.27 1 .67 1.22z"
  }))), _clipPath114 || (_clipPath114 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ds"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M17.55 25.98 2.64 17.87c-.4-.22-.67-.67-.67-1.22l14.91 8.11c.01.56.27 1 .67 1.22"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a445c",
    d: "M18.35 14.07 3.44 5.96 45.74.01l14.91 8.11z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#20384e",
    d: "M16.89 24.76 1.98 16.65l.01-8.93 14.91 8.11z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#314d68",
    d: "M60.65 8.12c.79-.11 1.43.5 1.43 1.35l-.02 8.94c0 .86-.64 1.65-1.44 1.76l-42.3 5.94c-.8.11-1.44-.49-1.44-1.35l.02-8.94c0-.86.64-1.65 1.44-1.76l42.31-5.94zM30.71 20.23c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.03.77 1.76 1.73 1.63m7.65-1.08c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.03.77 1.77 1.73 1.63m-15.3 2.15c.96-.13 1.74-1.09 1.74-2.12s-.78-1.76-1.73-1.63c-.96.13-1.74 1.09-1.74 2.12-.01 1.03.77 1.77 1.73 1.63m27.77-2.95.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.4-.06.74-.47.74-.9m3.62-.51.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.06.74-.47.74-.9m-7.26 1.02.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.06.74-.46.74-.9m10.89-1.53.01-5.63c0-.45-.33-.75-.74-.69-.41.06-.74.46-.74.9l-.01 5.63c0 .44.33.75.74.69.41-.06.74-.47.74-.9"
  })), _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "du",
    d: "M16.9 15.83 1.99 7.72c0-.86.64-1.65 1.44-1.76l14.91 8.11c-.79.11-1.43.9-1.44 1.76z"
  }))), _clipPath115 || (_clipPath115 = /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#du"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dv)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21394f",
    d: "M16.9 15.83 1.99 7.72c0-.21.04-.42.11-.61l14.91 8.11c-.07.19-.11.4-.11.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#223a51",
    d: "M17.02 15.21 2.11 7.1c.03-.08.07-.16.11-.24l14.91 8.11c-.05.08-.08.16-.11.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233b52",
    d: "M17.12 14.97 2.21 6.86c.04-.07.07-.13.12-.19l14.91 8.11c-.04.06-.08.13-.12.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243c53",
    d: "M17.24 14.78 2.33 6.67c.04-.06.08-.11.13-.16l14.91 8.11c-.04.05-.09.1-.13.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253e55",
    d: "M17.37 14.62 2.46 6.51l.15-.15 14.91 8.11c-.05.04-.1.09-.15.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263f56",
    d: "M17.52 14.47 2.61 6.36c.06-.05.11-.1.17-.14l14.91 8.11c-.06.04-.12.09-.17.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274058",
    d: "M17.69 14.33 2.78 6.22c.07-.05.15-.1.23-.13l14.91 8.11c-.07.03-.15.08-.23.13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#284159",
    d: "M17.93 14.2 3.02 6.08c.13-.06.27-.11.42-.13l14.91 8.11c-.15.03-.29.07-.42.14"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.60f05f8d57209203f6c26abaeb82b77f.svg";
export { ForwardRef as ReactComponent };